import assign from "lodash/assign";
import camelCase from "lodash/camelCase";
import capitalize from "lodash/capitalize";
import ceil from "lodash/ceil";
import clone from "lodash/clone";
import cloneDeep from "lodash/cloneDeep";
import compact from "lodash/compact";
import concat from "lodash/concat";
import debounce from "lodash/debounce";
import difference from "lodash/difference";
import differenceWith from "lodash/differenceWith";
import drop from "lodash/drop";
import each from "lodash/each";
import escape from "lodash/escape";
import every from "lodash/every";
import filter from "lodash/filter";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import findLast from "lodash/findLast";
import first from "lodash/first";
import flatMap from "lodash/flatMap";
import flatten from "lodash/flatten";
import floor from "lodash/floor";
import forEach from "lodash/forEach";
import get from "lodash/get";
import groupBy from "lodash/groupBy";
import has from "lodash/has";
import head from "lodash/head";
import identity from "lodash/identity";
import includes from "lodash/includes";
import indexOf from "lodash/indexOf";
import intersection from "lodash/intersection";
import intersectionWith from "lodash/intersectionWith";
import isArray from "lodash/isArray";
import isBoolean from "lodash/isBoolean";
import isDate from "lodash/isDate";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isEqualWith from "lodash/isEqualWith";
import isFunction from "lodash/isFunction";
import isInteger from "lodash/isInteger";
import isNil from "lodash/isNil";
import isNull from "lodash/isNull";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isUndefined from "lodash/isUndefined";
import join from "lodash/join";
import keyBy from "lodash/keyBy";
import keys from "lodash/keys";
import last from "lodash/last";
import lowerCase from "lodash/lowerCase";
import lowerFirst from "lodash/lowerFirst";
import map from "lodash/map";
import mapKeys from "lodash/mapKeys";
import mapValues from "lodash/mapValues";
import max from "lodash/max";
import maxBy from "lodash/maxBy";
import merge from "lodash/merge";
import mergeWith from "lodash/mergeWith";
import min from "lodash/min";
import minBy from "lodash/minBy";
import omit from "lodash/omit";
import omitBy from "lodash/omitBy";
import orderBy from "lodash/orderBy";
import padEnd from "lodash/padEnd";
import parseInt from "lodash/parseInt";
import pick from "lodash/pick";
import pickBy from "lodash/pickBy";
import pull from "lodash/pull";
import random from "lodash/random";
import range from "lodash/range";
import reduce from "lodash/reduce";
import reject from "lodash/reject";
import remove from "lodash/remove";
import repeat from "lodash/repeat";
import reverse from "lodash/reverse";
import round from "lodash/round";
import set from "lodash/set";
import size from "lodash/size";
import slice from "lodash/slice";
import some from "lodash/some";
import sortBy from "lodash/sortBy";
import sortedUniq from "lodash/sortedUniq";
import startCase from "lodash/startCase";
import startsWith from "lodash/startsWith";
import sum from "lodash/sum";
import sumBy from "lodash/sumBy";
import tail from "lodash/tail";
import take from "lodash/take";
import takeRight from "lodash/takeRight";
import toArray from "lodash/toArray";
import toNumber from "lodash/toNumber";
import toString from "lodash/toString";
import toUpper from "lodash/toUpper";
import trim from "lodash/trim";
import trimEnd from "lodash/trimEnd";
import union from "lodash/union";
import unionBy from "lodash/unionBy";
import uniq from "lodash/uniq";
import uniqBy from "lodash/uniqBy";
import upperCase from "lodash/upperCase";
import upperFirst from "lodash/upperFirst";
import values from "lodash/values";
import without from "lodash/without";
import xor from "lodash/xor";

export default {
  assign,
  camelCase,
  capitalize,
  ceil,
  clone,
  cloneDeep,
  compact,
  concat,
  debounce,
  difference,
  differenceWith,
  drop,
  each,
  escape,
  every,
  filter,
  find,
  findIndex,
  findLast,
  first,
  flatMap,
  flatten,
  floor,
  forEach,
  get,
  groupBy,
  has,
  head,
  identity,
  includes,
  indexOf,
  intersection,
  intersectionWith,
  isArray,
  isBoolean,
  isDate,
  isEmpty,
  isEqual,
  isEqualWith,
  isFunction,
  isInteger,
  isNil,
  isNull,
  isNumber,
  isObject,
  isString,
  isUndefined,
  join,
  keyBy,
  keys,
  last,
  lowerCase,
  lowerFirst,
  map,
  mapKeys,
  mapValues,
  max,
  maxBy,
  merge,
  mergeWith,
  min,
  minBy,
  omit,
  omitBy,
  orderBy,
  padEnd,
  parseInt,
  pick,
  pickBy,
  pull,
  random,
  range,
  reduce,
  reject,
  remove,
  repeat,
  reverse,
  round,
  set,
  size,
  slice,
  some,
  sortBy,
  sortedUniq,
  startCase,
  startsWith,
  sum,
  sumBy,
  tail,
  take,
  takeRight,
  toArray,
  toNumber,
  toString,
  toUpper,
  trim,
  trimEnd,
  union,
  unionBy,
  uniq,
  uniqBy,
  upperCase,
  upperFirst,
  values,
  without,
  xor
};
